import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../constants/queryKeys";
import {
  getSupplyChainDashboardOptions,
  SupplyChainDashboardOptions,
} from "../../api/supplyChain/getSupplyChainDashboardOptions";
import { AxiosInstance } from "axios";
import { SUPPLY_CHAIN_ACTIVE } from "../../constants/generated";
import { hardcodedDashboardOptions } from "./hardcodedDashboardOptions";

export const initialDashboardOptions: SupplyChainDashboardOptions = {
  genres: [],
  languages: [],
  countries: [],
  product_types: [],
  parental_advisories: [],
};

const useGetSupplyDashboardOptionsQuery = (axiosInstance: AxiosInstance) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_SUPPLY_CHAIN_DASHBOARD_OPTIONS],
    queryFn: async () => {
      // TODO: add analytics before launch.
      if (!SUPPLY_CHAIN_ACTIVE) {
        return hardcodedDashboardOptions;
      }
      return await getSupplyChainDashboardOptions(axiosInstance);
    },
    staleTime: Infinity,
  });
};

export default useGetSupplyDashboardOptionsQuery;
